import { ComponentProps } from "react";
import { TextBox, TextBoxStates } from "store/features/memeGenerator/types";
import { useDragHandler } from "./useDragHandler";

export interface RotateHandlerProps {
    textBox: TextBox;
}

export const DragHandler = ({ textBox }: RotateHandlerProps) => {
    const { dragHandlers, isDragging } = useDragHandler(textBox);
    if (textBox.state === TextBoxStates.BLUR) return null;
    return (
        <div
            className={`group ${
                isDragging ? "bg-irBlue-400" : "bg-white"
            } hover:bg-irBlue-400 p-1 rounded-full cursor-move touch-none pointer-events-auto mg-handler-circle-shadow`}
            {...dragHandlers}
        >
            <DragHandleIcon className={`${isDragging ? "fill-white" : "fill-black"} group-hover:fill-white`} />
        </div>
    );
};

interface DragHandleIcon {
    className: ComponentProps<"svg">["className"];
}

const DragHandleIcon = ({ className }: DragHandleIcon) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 24 24"
            className={`${className}`}
        >
            <path
                fillRule="evenodd"
                d="M14.22 6.573a.75.75 0 101.06-1.06l-2.145-2.146a1.25 1.25 0 00-1.77 0L9.22 5.513a.75.75 0 001.06 1.06l1.22-1.22v5.899H5.602l1.22-1.22a.75.75 0 00-1.06-1.06l-2.147 2.145a1.251 1.251 0 000 1.77l2.146 2.145a.75.75 0 101.06-1.06l-1.219-1.22H11.5v5.897l-1.22-1.22a.75.75 0 10-1.06 1.061l2.145 2.146a1.248 1.248 0 001.77 0l2.145-2.146a.75.75 0 10-1.06-1.06L13 18.65v-5.898h5.898l-1.22 1.22a.75.75 0 001.06 1.06l2.147-2.146a1.252 1.252 0 000-1.77l-2.146-2.145a.75.75 0 00-1.06 1.06l1.219 1.22H13V5.354l1.22 1.22z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
};
